import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import * as EmailUtils from '@/checkout-instore-legacy/utils/EmailUtils'
import PromiseGroupUtils from '@/checkout-instore-legacy/utils/PromiseGroupUtils'
import { logClickEvent } from '@/checkout-instore-legacy/utils/EventHelper'
import { getDocumentType } from '@/checkout-instore-legacy/utils/orderFormUtils'
import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import classNames from 'classnames'
import getClassStyle from '@/checkout-instore-legacy/utils/getClassStyle'
import { formatPhone } from '@/checkout-instore-legacy/customer/utils'
import { maskDocument } from '@/checkout-instore-legacy/utils/DocumentUtils'

function IdentificationSummary({
  clientProfileData,
  storePreferencesData,
  goToIdentificationPage,
  active,
}) {
  const actionColor = getClassStyle('c-on-action-secondary', 'color')
  const loading = !PromiseGroupUtils.areGroupsEmpty([
    'checkout/identification',
    'checkout/first-identification',
  ])

  const handleClick = () => {
    if (loading) {
      return
    }
    logClickEvent('summary-identification', 'Sale')

    setTimeout(() => {
      goToIdentificationPage(clientProfileData)
    }, 280)
  }

  const email =
    clientProfileData && clientProfileData.email
      ? EmailUtils.clearIfInStoreAnonymousEmail(clientProfileData.email)
      : null
  const documentType = getDocumentType({ storePreferencesData })
  const document = clientProfileData
    ? maskDocument({ documentNumber: clientProfileData.document, documentType })
    : null
  const firstName = clientProfileData ? clientProfileData.firstName : null
  const lastName = clientProfileData ? clientProfileData.lastName : null
  const phone = clientProfileData ? clientProfileData.phone : null

  let identificationSummaryText

  if (loading) {
    identificationSummaryText = (
      <div className="text-loading mocked light-silver">
        {'Nenhum'}
        <br />
        {'Registro'}
      </div>
    )
  } else if (firstName && lastName) {
    identificationSummaryText = (
      <span>
        {firstName} {lastName}
      </span>
    )
  } else if (email) {
    identificationSummaryText = <span>{email}</span>
  } else if (document) {
    identificationSummaryText = (
      <span>
        {documentType} {document}
      </span>
    )
  } else {
    identificationSummaryText = (
      <span>
        <FormattedMessage id="anonymousLabel" />
      </span>
    )
  }

  return (
    <div className="bb b--black-10 black-80">
      <div
        id="summary-identification"
        className={classNames(
          'flex flex-row pv5 pl6 pointer hover-bg-action-secondary',
          {
            'bl-l b--action-primary bw2-l': active,
          }
        )}
        onClick={handleClick}
      >
        <div className="flex mt2-ns mr2">
          <div className="flex-none">
            <Icon type="user" size={20} color={actionColor} />
          </div>
        </div>
        <div className="pa3-ns flex flex-column pt1 pt0-ns">
          <div
            data-testid="identification-text"
            className="c-on-action-secondary ttu f6 f4-ns f6-l"
          >
            {identificationSummaryText}
          </div>
          {firstName ? (
            <div className="f6 f4-ns mt3 mt5-ns mt0-l lh-copy f6-l">
              {firstName && email ? (
                <div className="dib-ns db-l" data-testid="email">
                  {email}
                </div>
              ) : null}
              {(firstName || email) && document ? (
                <div className="dib-ns" data-testid="document">
                  {documentType} {document}
                </div>
              ) : null}
              {phone ? (
                <div className="dib-ns db-l" data-testid="phone">
                  {formatPhone(phone)}
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

IdentificationSummary.propTypes = {
  clientProfileData: PropTypes.object,
  storePreferencesData: PropTypes.object,
  goToIdentificationPage: PropTypes.func,
  active: PropTypes.bool,
}

export default IdentificationSummary
